module.exports = __webpack_public_path__ + "img/32.405865c4.png";